import { createSelector } from "reselect";
import { prop } from "ramda";
import { IRootStateProps } from "types/reducers";

const selectContext = (state: IRootStateProps) => state.context;

export const selectFeatureFlags = createSelector(
  selectContext,
  prop("featureFlags")
);
